import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-participant-profile',
    templateUrl: './participant-profile.component.html',
    styleUrls: ['./participant-profile.component.scss'],
    standalone: false
})
export class ParticipantProfileComponent {
  translations: any;

  constructor(
    private router: Router,
    private authservice: AuthService,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }

  navigate() {
    this.router.navigate(['/participants/edit-participant-profile/' + this.authservice.getUserLoginData().publicId]);
  }

}
